// When a task's reminder fires. The client computes `remindAt` as an absolute
// moment in the device's time zone. A waiting task with a follow-up time is
// reminded then; otherwise the due time minus the chosen offset. A Do it on day
// has no time and never reminds. Null when there is nothing to remind of, or
// the one-off is done.

import type { Task } from '@/types'
import { dateTimeFrom } from './dates'

export const REMINDER_OFFSETS = [
  { label: 'At time', offsetMin: 0 },
  { label: '10 min', offsetMin: 10 },
  { label: '1 hour', offsetMin: 60 },
  { label: '1 day', offsetMin: 24 * 60 },
] as const

type ReminderInput = Pick<Task, 'kind' | 'done' | 'dueDate' | 'dueTime' | 'reminder' | 'waiting' | 'followUpDate' | 'followUpTime'>

export function computeRemindAt(t: ReminderInput): Date | null {
  if (t.kind === 'once' && t.done) return null
  if (t.waiting && t.followUpDate && t.followUpTime) return dateTimeFrom(t.followUpDate, t.followUpTime)
  if (!t.reminder || !t.dueDate || !t.dueTime || t.kind === 'routine') return null
  return new Date(dateTimeFrom(t.dueDate, t.dueTime).getTime() - t.reminder.offsetMin * 60_000)
}

export function reminderLabel(t: Pick<Task, 'reminder'>): string {
  if (!t.reminder) return 'None'
  return REMINDER_OFFSETS.find((o) => o.offsetMin === t.reminder!.offsetMin)?.label ?? `${t.reminder.offsetMin} min`
}
